export default "__VITE_ASSET__DeffY97K__"